import { useMediaQuery } from "./useMediaQuery";

const smallViewportBreakpoint = 980;

export function useIsSmallViewport() {
  return useMediaQuery(`(max-width: ${smallViewportBreakpoint}px)`);
}
